angular.module('impactx.cscontract').controller('CSCNumberingSchemasCtrl', [
    '$scope',
    'dataGen',
    '$routeParams',
    'ToastService',
    'BackService',
    'TranslationService',
    'ToolbarService',
    'PartialDialogsService',
    CSCNumberingSchemasCtrl
]);

function CSCNumberingSchemasCtrl($scope, dataGen, $routeParams, ToastService, BackService, TranslationService, ToolbarService, PartialDialogsService) {
    var self = this;

    self.save = function ($event) {
        return dataGen.postAsForm($scope, {numberingschemas: $scope.data}, "/cscontract/numberingschemas/save").then(function () {
            ToastService.openStandardToast(TranslationService.get("saveSuccess"));
            PartialDialogsService.showDialog($event, PartialDialogsService.TYPE.CONTRACT, $routeParams.cscId, 'cscnumberingschemas', $routeParams.preSetId ? $routeParams.preSetId : 0);
        });
    };

    dataGen.getData($scope, {cscId: $routeParams.cscId}, "/cscontract/numberingschemas/view").then(function () {
        $scope.saveTrns = TranslationService.get("save");
        defineButtons();
    });

    function defineButtons() {
        var buttonDefinition = [
            {
                label: $scope.saveTrns,
                action: self.save,
                type: 'validation',
                condition: isEditable,
                params: {
                    form: $scope.dialogData
                }
            }
        ];
        ToolbarService.setButtons(buttonDefinition);
    }

    function isEditable() {
        return !$scope.data.readOnly && !($scope.data.needsVat && $scope.data.paymentType.selected.id === 16 && !$scope.data.mayInsertVat);
    }
}